import Link from "next/link";
import styles from "./CTAModal.module.css";
import { AppStoreNewNoLink } from "@/components/home/Appstore";
import { AndroidAppStoreMediumNoLink } from "@/components/home/AndroidStore";
import {
  generateWebRecommendationLink,
  View,
} from "@/_firebase/generateDymaicLink";
import { useRouter } from "next/router";

type CTAModalProps = {
  userName: string | null;
  HeadingText: string;
  uid: string;
};

export default function CTAModal(props: CTAModalProps) {
  const router = useRouter();
  async function handleClick() {
    await generateWebRecommendationLink(props.uid, View.webProfile)
      .then((res) => {
        router.push(res);
      })
      .catch((err) => {
        router.push("/");
      });
  }
  return (
    <div id="modalParent" className={styles.modalParent}>
      <div className={styles.modalWrapper}>
        <div className={styles.modalBox}>
          <h1>{props.HeadingText}</h1>
          <p className={styles.subHeading}>
            You must connect with @{props.userName ?? "this user"} on the
            Dimensional app to see this.
          </p>
          <div onClick={() => handleClick()} className={styles.storeDiv}>
            <AppStoreNewNoLink />
            <AndroidAppStoreMediumNoLink />
          </div>
          <Link href={"/"}>
            <p className={styles.bottomText}>Learn more about Dimensional</p>
          </Link>
        </div>
      </div>
    </div>
  );
}
